import { computed, type Signal, linkedSignal } from '@angular/core';

import type { TableBusyState, TableContentState } from './types';

export function toTableBusyState(source: {
  isInitialLoading: Signal<boolean>;
  isReloading: Signal<boolean>;
}): Signal<TableBusyState> {
  return computed(() => {
    if (source.isInitialLoading()) {
      return 'initialLoading';
    }
    if (source.isReloading()) {
      return 'reloading';
    }
    return 'idle';
  });
}

export function toTableContentState(source: {
  hasRows: Signal<boolean>;
  hasError: Signal<boolean>;
  hasQuery: Signal<boolean>;
  isReloading: Signal<boolean>;
}): Signal<TableContentState> {
  const rawState = computed<TableContentState>(() => {
    if (source.hasRows()) {
      return 'rows';
    }
    if (source.hasError()) {
      return 'error';
    }
    if (source.hasQuery()) {
      return 'noResults';
    }
    return 'empty';
  });

  return linkedSignal<{ state: TableContentState; reloading: boolean }, TableContentState>({
    source: () => ({
      state: rawState(),
      reloading: source.isReloading(),
    }),
    computation: (current, previous) => {
      if (current.reloading && current.state !== 'rows' && current.state !== 'error' && previous?.value) {
        return previous.value;
      }

      return current.state;
    },
  });
}
